import { WidgetType } from "@codemirror/view";

export class SpaceWidget extends WidgetType {
    constructor(width) {
        super();
        this.width = width;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-space");
        element.style.width = this.width;
        return element;
    }

    eq(widget) {
        return widget.width === this.width;
    }

    updateDOM(element) {
        element.style.width = this.width;
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}

export const COMMAND_WIDTHS = new Map([
    ["\\thinspace", "calc(3em / 18)"],
    ["\\,", "calc(3em / 18)"],
    ["\\negthinspace", "calc(-3em / 18)"],
    ["\\!", "calc(-3em / 18)"],
    ["\\medspace", "calc(4em / 18)"],
    ["\\:", "calc(4em / 18)"],
    ["\\>", "calc(4em / 18)"],
    ["\\thickspace", "calc(5em / 18)"],
    ["\\;", "calc(5em / 18)"],
    ["\\negthickspace", "calc(-5em / 18)"],
    ["\\enspace", "0.5em"],
    ["\\quad", "1em"],
    ["\\qquad", "2em"],
]);

export function createSpaceCommand(command) {
    const width = COMMAND_WIDTHS.get(command);
    if (width !== undefined) {
        return new SpaceWidget(width);
    }
    return undefined;
}

export function hasSpaceSubstitution(command) {
    return COMMAND_WIDTHS.has(command);
}
